import type { Me } from "../../lib/me";
import type { ManualForm } from "../../pages/vendorFlow";
import { RoleButton } from "../RequireRole";

/** A check typed by hand: the model number is required, the rest helps the search find the part. */
export function ManualEntry({ form, onChange, onStart, busy, me }: {
  form: ManualForm; onChange: (f: ManualForm) => void; onStart: () => void; busy: boolean; me: Me | null | undefined;
}) {
  const field = (name: keyof ManualForm, placeholder: string) => (
    <input aria-label={placeholder} placeholder={placeholder} value={form[name]}
           onChange={(e) => onChange({ ...form, [name]: e.target.value })} />
  );
  return (
    <>
      {field("manufacturer", "Manufacturer")}
      {field("model_number", "Model number (required)")}
      {field("part_number", "Part number")}
      {field("description", "Description")}
      <RoleButton role="engineer" me={me} onClick={onStart} disabled={busy || !form.model_number.trim()}>
        {busy ? "Starting..." : "Start check"}
      </RoleButton>
    </>
  );
}
